<script>

    import { ModalStore  } from '../stores'

    import Modal from '../$components/modal.svelte'

    import User from '../users/user.svelte'
    import UserUpdate from '../users/user.update.svelte'
    import UserUpdateEmail from '../users/user.update.email.svelte'
    import UserUpdatePassword from '../users/user.update.password.svelte'

</script>

<User />

<Modal id="UserUpdate" title="Actualizar usuario">
    <UserUpdate on:updated={ModalStore.close} on:canceled={ModalStore.close} />
</Modal>

<Modal id="UserUpdateEmail" title="Actualizar correo">
    <UserUpdateEmail on:updated={ModalStore.close} on:canceled={ModalStore.close} />
</Modal>

<Modal id="UserUpdatePassword" title="Actualizar contraseña">
    <UserUpdatePassword on:updated={ModalStore.close} on:canceled={ModalStore.close} />
</Modal>